import React from "react";

const NullCell = () => (
  <div style={{ textAlign: "center", color: "#c1c1c1" }}>—</div>
);

export default NullCell;
